import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H3 } from '#app/components/typography/h3.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H3',
}

const component: componentProps = {
	name: 'H3',
	shortName: 'H3',
	fileName: 'h3',
	category: 'typography',
	description: ['H3 heading component.'],
	features: ['Drop-in replacement for the native <h3> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<H3>This is an h3 heading</H3>`,
	styling: `.h3 {
	@apply text-muted-900 mt-fluid-14 mb-fluid-9 text-fluid-2xl max-w-prose font-sans font-bold capitalize;
	/* If h3 has h4 after it */
	&:has(+ .h4) {
		@apply mb-fluid-8;
	}
	/* Typographical elements after h3 */
	& + .h4,
	& + .p {
		@apply mt-0;
	}
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<H3>This is an h3 heading</H3>
			<Features features={features} />
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
